/**
 * Posts to the Cloudflare Worker for review; falls back to the form's native Shopify submission
 * on any failure (network error, timeout, Worker error).
 *
 * The submit button must stay type="button" (see blocks/b2b-signup-form.liquid) so a click never
 * fires a native submit except through the explicit fallback below.
 */
(function () {
  var FETCH_TIMEOUT_MS = 6000;

  document.querySelectorAll('.js-b2b-signup-form').forEach(function (form) {
    var submitButton = form.querySelector('.b2b-signup-form__submit');
    if (!submitButton) return;

    submitButton.addEventListener('click', function () {
      if (form.dataset.fallbackInProgress === 'true') return;

      // type="button" skips native validation-on-submit, so check manually.
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var container = form.closest('.b2b-signup-form');
      var automationUrl = container && container.dataset.automationUrl;
      if (!automationUrl) {
        submitNatively(form);
        return;
      }

      var payload = buildPayload(form);
      submitButton.disabled = true;

      var controller = new AbortController();
      var timeoutId = setTimeout(function () {
        controller.abort();
      }, FETCH_TIMEOUT_MS);

      fetch(automationUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && data.ok, data: data };
          });
        })
        .then(function (result) {
          clearTimeout(timeoutId);
          if (!result.ok) {
            submitNatively(form);
            return;
          }
          try {
            showSuccess(form);
          } catch (e) {
            /* already saved server-side; a cosmetic render failure isn't worth resubmitting over */
          }
        })
        .catch(function () {
          clearTimeout(timeoutId);
          submitNatively(form);
        });
    });
  });

  function buildPayload(form) {
    var data = new FormData(form);
    var get = function (name) {
      var value = data.get(name);
      return typeof value === 'string' ? value.trim() : '';
    };

    return {
      website: get('contact[website]'), // honeypot — real visitors leave this blank
      companyName: get('contact[Virksomhedsnavn]'),
      cvr: get('contact[CVR-nummer]'),
      ean: get('contact[EAN-nummer]'),
      name: get('contact[name]'),
      email: get('contact[email]'),
      phone: get('contact[phone]'),
      billingStreet: get('contact[Faktureringsadresse - Gade og nr.]'),
      billingZip: get('contact[Faktureringsadresse - Postnr.]'),
      billingCity: get('contact[Faktureringsadresse - By]'),
      billingCountry: get('contact[Faktureringsadresse - Land]'),
      deliveryStreet: get('contact[Leveringsadresse - Gade og nr.]'),
      deliveryZip: get('contact[Leveringsadresse - Postnr.]'),
      deliveryCity: get('contact[Leveringsadresse - By]'),
      deliveryCountry: get('contact[Leveringsadresse - Land]'),
      comment: get('contact[body]'),
    };
  }

  function submitNatively(form) {
    form.dataset.fallbackInProgress = 'true';
    form.submit();
  }

  function showSuccess(form) {
    var container = form.closest('.b2b-signup-form');
    var successMessage = (container && container.dataset.successMessage) || 'Tak for din ansøgning.';

    var successEl = document.createElement('div');
    successEl.className = 'b2b-signup-form__success';
    successEl.setAttribute('tabindex', '-1');
    successEl.textContent = successMessage;

    form.innerHTML = '';
    form.appendChild(successEl);
    successEl.focus();
  }
})();
